import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./ProgressBar.module.less";

export type ProgressBarProps = {
	value: number;
	trackingId: string;
	ariaLabel: string;
};

export const ProgressBar = (props: ProgressBarProps): ReactElement => {
	const {
		value,
		trackingId,
		ariaLabel
	} = props;

	return (
		<progress
			{...setTrackingId(trackingId)}
			className={styles.root}
			value={value}
			max={100}
			aria-label={ariaLabel}
		/>
	);
};
ProgressBar.displayName = "ProgressBar";